import { DividerSizeTokens, } from '@voltmoney/schema';
export const dividerSizeTypeTokensMap = {
    [DividerSizeTokens.SM]: 1,
    [DividerSizeTokens.MD]: 2,
    [DividerSizeTokens.LG]: 4,
};
